__turbopack_context__.v({
  "body": "ArticleBody-module-scss-module__ufu52a__body",
});
